module.exports = __webpack_public_path__ + "templates.collapse-bottom-7192e9c8.html";